interface CannedResponsesCommandsParser {
  startsWithSlash: boolean;
  showFilterTagsSelector: boolean;
  searchQuery: string;
  filterTag: string;
}

export const cannedResponsesCommandsParser = (
  userInput: string
): CannedResponsesCommandsParser => {
  const result: CannedResponsesCommandsParser = {
    startsWithSlash: false,
    showFilterTagsSelector: false,
    searchQuery: '',
    filterTag: '',
  };

  if (!userInput || !userInput.startsWith('/')) {
    return result;
  }

  result.startsWithSlash = true;

  const filterRegex = /#(?:"([^"]+)"|([^"\s]+))/u;
  const matches = userInput.match(filterRegex);

  if (matches) {
    result.filterTag = matches[0].substring(1);
    result.searchQuery = userInput
      .replace(filterRegex, '')
      .replace('#', '')
      .substring(1)
      .trim();
  } else {
    result.searchQuery = userInput.substring(1).trim();
  }

  return result;
};
